import React, { useState } from "react";
import { Radio } from "antd";

import DashboardLayout from "../../layout/dashboardLayout/DashboardLayout";
import IntakeFlow from "./IntakeFlow";
import DisplayView from "./DisplayView";
import { SAMPLE_STATE } from "./sampleData";
import "./breakdownWorksheet.css";

/**
 * Breakdown Worksheet — a MOCK. Nothing here reads or writes the API.
 *
 * It proposes replacing the procedure-code-centric breakdown with the model an
 * established practice already uses on paper: capture the plan once against
 * procedure FAMILIES (each with an editable category, because the same procedure
 * sits in different categories from carrier to carrier), and read it afterwards
 * as a one-page summary led by whatever makes the plan unusual.
 *
 * Two surfaces, one in-memory state, because they are different jobs:
 *   Intake  — a guided flow for the single call where the plan is recorded.
 *   Display — the at-a-glance view read at the chair every day after.
 *
 * Both are seeded from SAMPLE_STATE so the page has something to show on open.
 */
export default function BreakdownWorksheetPage() {
  const [mode, setMode] = useState("display");
  const [state, setState] = useState(SAMPLE_STATE);
  const [stepIndex, setStepIndex] = useState(0);

  return (
    <DashboardLayout>
      <div className="bw-page">
        <div className="bw-header">
          <div>
            <h1 className="bw-title">
              Breakdown Worksheet
              <span className="bw-mockchip">mock-up</span>
            </h1>
            <p className="bw-subtitle">
              A proposed replacement for the code-by-code breakdown: capture a plan once
              against procedure families, then read it as a single page led by whatever
              makes the plan unusual. Nothing on this page is connected — it is here to
              look at and argue with.
            </p>
          </div>
          <Radio.Group
            value={mode}
            onChange={function (e) { setMode(e.target.value); }}
            optionType="button"
            buttonStyle="solid"
            options={[
              { label: "Collected breakdown", value: "display" },
              { label: "Intake (new plan)", value: "intake" },
            ]}
          />
        </div>

        {mode === "intake" ? (
          <IntakeFlow
            state={state}
            setState={setState}
            stepIndex={stepIndex}
            setStepIndex={setStepIndex}
          />
        ) : (
          <DisplayView
            state={state}
            onChangeFamilies={function (families) {
              setState(Object.assign({}, state, { families: families }));
            }}
            onEdit={function () { setMode("intake"); }}
          />
        )}
      </div>
    </DashboardLayout>
  );
}
